import { app } from '../../bootstrap/core';
import { inboxState } from './inbox.state';
import { inboxComponent } from './inbox.component';
import { InboxJobService } from './inbox.job.service';
import { InboxDocumentService } from './inbox.document.service';
import { IbanPrefix, DocumentStatus, DocumentTypes, InboxTabs } from './inbox.constants';
import './documentList/documentList';
import './categorizeIncomingDocument/categorizeIncomingDocument';
import './documentListItem/documentListItem';

angular.module(app.name)
  .config(inboxState)
  .component(inboxComponent.name, inboxComponent)
  .constant('DocumentStatus', DocumentStatus)
  .constant('DocumentTypes', DocumentTypes)
  .constant('IbanPrefix', IbanPrefix)
  .constant('InboxTabs', InboxTabs)
  .service('jobService', InboxJobService)
  .service('inboxDocumentService', InboxDocumentService);
